import { hashStringToSeed } from "./dailyRandom";

// Fixed, validated categorical palette (see src/styles/theme.css --geo-1..8 - dataviz-skill
// checked: lightness band, chroma floor, CVD separation, contrast, all pairs since this is a
// choropleth where any two shapes can be neighbors). Never cycle beyond these 8 slots' order.
const SLOT_COUNT = 8;

function hashSlot(code) {
  return (hashStringToSeed(code) % SLOT_COUNT) + 1;
}

/**
 * CSS var reference (e.g. "var(--geo-3)") for a country's fixed categorical slot, with no
 * knowledge of which other countries are currently displayed. Two countries can collide (real
 * neighbors have — see PR #21 review); prefer getCountryColorMap when the active country list is
 * known, since it resolves collisions within that set.
 */
export function getCountryColorVar(countryCode) {
  return `var(--geo-${hashSlot(countryCode)})`;
}

/**
 * Assigns each of `countryCodes` a distinct slot when there are <= SLOT_COUNT of them: sorted
 * alphabetically (deterministic, independent of fetch-order) and hash-preferred, with a collision
 * resolved by taking the next free slot. Stable for any code whose preferred slot isn't contested;
 * a code with an active count > SLOT_COUNT falls back to (possibly colliding) hash slots — the
 * palette only has 8 validated colors.
 */
export function getCountryColorMap(countryCodes) {
  const sorted = [...new Set(countryCodes)].sort();
  const used = new Set();
  const map = new Map();
  for (const code of sorted) {
    let slot = hashSlot(code);
    if (sorted.length <= SLOT_COUNT) {
      let attempts = 0;
      while (used.has(slot) && attempts < SLOT_COUNT) {
        slot = (slot % SLOT_COUNT) + 1;
        attempts++;
      }
    }
    used.add(slot);
    map.set(code, `var(--geo-${slot})`);
  }
  return map;
}
